import { render, staticRenderFns } from "./ImporterDetail.vue?vue&type=template&id=a15e20a0&"
import script from "./ImporterDetail.vue?vue&type=script&lang=js&"
export * from "./ImporterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports